import Modal from "../../Modal";
import { DialogWrapper } from "../../containers";
import { TitleH2 } from "../../generic";
import { Button, Input } from "antd";
import React, { useState } from "react";
import { useArchiveChat } from "API/queries/chatApiQueries";
import { useNotifier } from "../../../context/ContextNotifier";
import { useTranslation } from "react-i18next";

export const ArchiveChatRequestModal: React.FC<{
  chatId: string;
  isShow: boolean;
  onClose: () => void;
  onArchived: () => void;
}> = ({ chatId, isShow, onClose, onArchived }) => {
  const archiveChat = useArchiveChat();
  const notifier = useNotifier();
  const { t } = useTranslation("chats");
  const [message, setMessage] = useState(
    String(t("archiveChatRequestModal.rejectMessage"))
  ); //"I am sorry, not interested"

  return (
    <Modal handleClose={onClose} isShow={isShow}>
      <DialogWrapper
        style={{
          minWidth: "500px"
        }}
      >
        <TitleH2>{t("archiveChatRequestModal.title")}</TitleH2>
        <div>
          <div className="cal"></div>
        </div>
        <div
          style={{
            display: "flex",
            gap: "10px",
            flexDirection: "column"
          }}
        >
          <Input.TextArea
            size="large"
            placeholder={t("archiveChatRequestModal.rejectReasonPlaceholder")}
            rows={2}
            value={message}
            disabled={archiveChat.isLoading}
            onChange={(e) => {
              setMessage(e.target.value);
            }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "8px"
            }}
          >
            <Button type={"default"} onClick={() => onClose()} size="large">
              {t("butCancel")}
            </Button>
            <Button
              type={"primary"}
              disabled={message.length === 0}
              onClick={() =>
                archiveChat.mutate(
                  {
                    chatId,
                    payload: {
                      message
                    }
                  },
                  {
                    onSuccess: () => {
                      onArchived();
                      notifier.success({
                        message: t(
                          "archiveChatRequestModal.chatArchivedMessage"
                        )
                      });
                    }
                  }
                )
              }
              loading={archiveChat.isLoading}
              size="large"
            >
              {t("archiveChatRequestModal.title")}
            </Button>
          </div>
        </div>
      </DialogWrapper>
    </Modal>
  );
};
